export function extractQueryParamsFromUrl(url) {
    const questionMarkIdx = url.indexOf("?");
    if (questionMarkIdx == -1)
        return new URLSearchParams();
    const sub = url.substring(questionMarkIdx, url.length);
    return new URLSearchParams(sub);
}
//# sourceMappingURL=url.js.map